import pino from 'pino';

const logger = pino({
  prettyPrint: process.env.NODE_ENV === "development",
  level: process.env.LOG_LEVEL || "info",
  serializers: {
    err: pino.stdSerializers.err,
    req: pino.stdSerializers.req
  },
  browser: {
    transmit: {
      level: "error",
      send: (_level, logEvent) => {
        if (typeof window !== "undefined" && window.track) {
          let eventDetails = null;
          for (const message of logEvent.messages) {
            if (message.msg && message.stack) {
              eventDetails = {
                message: message.msg,
                stack: message.stack
              };
            }
          }
          eventDetails = eventDetails || {
            message: JSON.stringify(logEvent.messages),
            stack: JSON.stringify(logEvent.bindings)
          };
          window.track("exception", eventDetails);
        }
      }
    }
  }
});

export { logger };
